const PROJECT_GRADIENTS = [
  "linear-gradient(135deg, #f87171 0%, #dc2626 100%)", // soft red
  "linear-gradient(135deg, #fb7185 0%, #be123c 100%)", // rose
  "linear-gradient(135deg, #f472b6 0%, #db2777 100%)", // soft pink
  "linear-gradient(135deg, #ec4899 0%, #9d174d 100%)", // magenta
  "linear-gradient(135deg, #e879f9 0%, #a21caf 100%)", // orchid
  "linear-gradient(135deg, #c084fc 0%, #7e22ce 100%)", // lilac
  "linear-gradient(135deg, #a855f7 0%, #6b21a8 100%)", // violet
  "linear-gradient(135deg, #7e22ce 0%, #4c1d95 100%)", // eggplant
  "linear-gradient(135deg, #fda4af 0%, #e11d48 100%)", // blush coral
  "linear-gradient(135deg, #fb923c 0%, #ea580c 100%)", // coral orange
  "linear-gradient(135deg, #fdba74 0%, #c2410c 100%)", // peach
  "linear-gradient(135deg, #f97316 0%, #9a3412 100%)", // tangerine
  "linear-gradient(135deg, #c2410c 0%, #7c2d12 100%)", // terracotta
  "linear-gradient(135deg, #fbbf24 0%, #d97706 100%)", // amber
  "linear-gradient(135deg, #eab308 0%, #a16207 100%)", // warm gold
  "linear-gradient(135deg, #d97706 0%, #78350f 100%)", // honey copper
  "linear-gradient(135deg, #a16207 0%, #451a03 100%)", // bronze
  "linear-gradient(135deg, #be123c 0%, #881337 100%)", // wine
  "linear-gradient(135deg, #9f1239 0%, #4c0519 100%)", // deep maroon
  "linear-gradient(135deg, #a8a29e 0%, #44403c 100%)", // warm stone
];

export const getProjectGradient = (key) => {
  const str = String(key ?? "");
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % PROJECT_GRADIENTS.length;
  return PROJECT_GRADIENTS[index];
};
